import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import ChineseClass from './ChineseClass';

const ClassGradePreK = () => {

  const this_class = {
    课程名称: "学龄前幼儿班(Pre-Kindergarten)",
    课程介绍:
    `
     继续教授与儿童日常生活紧密相关的生活用语，同时也使学生能认读一定量的汉字，
     正确地使用简单的中文会话，包括使用完整的句子和正确的发音。
     以轻松活泼的形式,寓教学于娱乐之中.
     `,
    教学语言: "中文",
    教学大纲: "Mon, Wed, Fri - 10:00 AM to 12:00 PM",
    课程内容: "",
    教学目的: "1. 学习与日常生活相关的中文词汇和表达方式。",
    授课方法: "通过游戏、歌曲和故事等多种形式，激发学生的学习兴趣，培养他们的语言能力。",
    教材: 
    `
    《中文练习册第九册A》    中国暨南大学华文学院编写2018年版
    《中文练习册第九册B》    中国暨南大学华文学院编写2018年版
  `,
    作业: "每周布置适量的作业，帮助学生巩固所学知识，并培养良好的学习习惯。",
    考核方法: `
    • 出席及课堂参与5%
    • 平时测验10%
    • 作业15%
    • 期中考试35%
    • 期末考试35%
    `
  };

  return (
    // <>

    //   <Box height={100} />

    //     <Box textAlign={'center'}>
    //       <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line' }}>
    //         作为学校公益教育项目的一部分，TriCLS 为 Pre-K 学生提供免学费中文课程（Tuition-Free），帮助更多幼儿接触中文语言和中华文化。
    //       </Typography>
    //     </Box>
    //     <Box textAlign={'center'}>
    //       <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line', color: 'red' }}>
    //         对于 Pre-K 项目，家庭只需负责 PTA 费用和教材费用。为了支持已经参与我们 TriCLS 社区的家庭，当前 TriCLS 学生的兄弟姐妹将获得优先考虑入学的机会。入学名额将根据实际情况而定，我们鼓励有意向的家庭尽早注册。
    //       </Typography>
    //     </Box>

    //     <ChineseClass class_introduction={this_class} />

    //   <Box sx={{ height: '80px' }}></Box>
    // </>


        <>
        <Box height={100} />

        <Grid container spacing={0} alignItems="center" justify="left">
            <Grid item xs={2} />
            <Grid item xs={8}>

                <Card>
                  <CardHeader title=''/>
                  <CardContent>
                                <Box textAlign={'left'}>
                    <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line', color: 'blue', fontWeight: 'bold' }}>
                      作为学校公益教育项目的一部分，TriCLS 为 Pre-K 学生提供免学费中文课程（Tuition-Free），帮助更多幼儿接触中文语言和中华文化。
                    </Typography>
                  </Box>
                  <Box textAlign={'left'}>
                    <Typography variant="body1" gutterBottom style={{ whiteSpace: 'pre-line', color: 'blue', fontWeight: 'bold' }}>
                      对于 Pre-K 项目，家庭只需负责 PTA 费用和教材费用。为了支持已经参与我们 TriCLS 社区的家庭，当前 TriCLS 学生的兄弟姐妹将获得优先考虑入学的机会。入学名额将根据实际情况而定，我们鼓励有意向的家庭尽早注册。
                    </Typography>
                  </Box>
                  </CardContent>
                </Card>


            </Grid> 
            <Grid item xs={2} />
            <Grid item xs={8}>
                            
            </Grid>
        </Grid>
          <ChineseClass class_introduction={this_class} />    
        <Box height={80} />
        </>

  )
}

export default ClassGradePreK